import { InternetStatus } from "@/components/commons/InternetStatus";
import { Toast } from "@/components/elements/Toast";
import { queryClient } from "@/constants/queryClient";
import { MaintenanceProvider } from "@/providers/MaintenanceProvider";
import theme from "@/theme";
import { FCC } from "@/types/common";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { jaJP } from "@mui/x-date-pickers/locales";
import { QueryClientProvider } from "@tanstack/react-query";
import "dayjs/locale/ja";

const jpLocale = jaJP.components.MuiLocalizationProvider.defaultProps.localeText;

export const AppProvider: FCC = ({ children }) => {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Toast />
        <LocalizationProvider dateAdapter={AdapterDayjs} localeText={jpLocale} adapterLocale="ja">
          <MaintenanceProvider>{children}</MaintenanceProvider>
        </LocalizationProvider>
        <InternetStatus />
      </ThemeProvider>
    </QueryClientProvider>
  );
};
